module.exports = __webpack_public_path__ + "static/hack-desio-8fb8fa901df9f69e90e7cd4473c9a37f.png";